import { MainLayout } from "@components/layouts/MainLayout";
import { BarChart2 } from "lucide-react";
import { PageHeader } from "@components/layouts/PageHeader";
import { Summary } from "@components/players/statistics/Summary";
import { GamesPrizes } from "@components/players/statistics/GamesPrizes";
import { Countries } from "@components/players/statistics/Countries";
import { MVP } from "@components/players/statistics/MVP";
import { useState } from "react";
import { useApiDataWithDateRange } from "@hooks/useApiDataWithDateRange";
import { addDays } from "date-fns";
import type { DateRange } from "react-day-picker";
import { DatePickerWithRange } from "@components/ui/date-range-picker";
import { Separator } from "@components/ui/separator";

export default function Statistics() {
  const [dateRange, setDateRange] = useState<DateRange | undefined>({
    from: addDays(new Date(), -30),
    to: new Date(),
  });

  const [allPlayerStats, loading, error] = useApiDataWithDateRange(
    "/api/superone/all-player-stats",
    dateRange,
    {
      transform: (res: any) => res?.data || [],
    }
  );

  return (
    <MainLayout>
      <div className="space-y-6 p-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-2">
          <PageHeader
            icon={<BarChart2 className="h-6 w-6 text-blue-600" />}
            title="Statistics"
            subtitle="Overview of player statistics and metrics."
          />
          <div className="mt-4 md:mt-0">
            <DatePickerWithRange
              defaultRange={dateRange}
              onDateChange={setDateRange}
            />
          </div>
        </div>
        <Separator className="mb-12" />
        <div className="space-y-8">
          <div className="pt-4 pb-4">
            <Summary
              allPlayerStats={allPlayerStats}
              loading={loading}
              error={error}
              startDate={dateRange?.from}
              endDate={dateRange?.to}
            />
          </div>
          <div className="pt-4 pb-4">
            <GamesPrizes
              allPlayerStats={allPlayerStats}
              loading={loading}
              error={error}
              startDate={dateRange?.from}
              endDate={dateRange?.to}
            />
          </div>
          <div className="pt-4 pb-4">
            <Countries
              allPlayerStats={allPlayerStats}
              loading={loading}
              error={error}
              startDate={dateRange?.from}
              endDate={dateRange?.to}
            />
          </div>
          <div className="pt-4 pb-4">
            {/* <MVP
              allPlayerStats={allPlayerStats}
              loading={loading}
              error={error}
            /> */}
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
